import { useAuth0 } from "@auth0/auth0-react";
// import { useContext } from "react";
import { useGetDetailes } from "../hooks/useGetDetailes";
// import { UserContex } from "./App2";

import Classes from "./style/home.module.css";
export default function Home() {
  const { user, isLoading } = useAuth0();
  // const { state } = useContext(UserContex);
  // invock custom hooks
  const { userDetailes, loading } = useGetDetailes();
  if (user) {
    return (
      <>
        <div className={Classes.container}>
          <div className={Classes.profile}>
            {isLoading ? (
              "Loading..."
            ) : (
              <div className={Classes.main_div}>
                <div className={Classes.userAvatar}>
                  <div className={Classes.avataContainer}>
                    <img src={user.picture} alt="useAvatar" />
                    <div>
                      {(user && user.name) ||
                        (userDetailes && userDetailes.userName)}
                    </div>
                  </div>
                </div>
                <div className={Classes.userInfo}>
                  <p>Name:{user.name}</p>
                  <p>Email: {user.email || "xxxxxxxxx"}</p>
                  <p>Phone No: xxxxxxxxx</p>
                  <h4>{"You logted with: " + user.sub.split("|")[0]}</h4>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
  if (userDetailes) {
    return (
      <>
        <div className={Classes.container}>
          <div className={Classes.profile}>
            {loading ? (
              "Loading..."
            ) : (
              <div className={Classes.main_div}>
                <div className={Classes.userAvatar}>
                  <div className={Classes.avataContainer}>
                    <img
                      src={`https://mahapravhu-furniture.vercel.app/uploads/${userDetailes.avatar}`}
                      alt="useAvatar"
                    />
                    <div>
                      {(userDetailes && userDetailes.name) ||
                        (userDetailes && userDetailes.userName)}
                    </div>
                  </div>
                </div>
                <div className={Classes.userInfo}>
                  <p>Name: {userDetailes.userName}</p>
                  <p>Email: {userDetailes.email}</p>
                  <p>Phone No: {userDetailes.mobileNo}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}
